module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/icons/menu-5cb88be82ccaec4836b23f18ca154a65.svg";